import React, { useCallback } from "react";
import { MakePostModalsProps } from "./modal-validate-username-type";
import { TitleStyled } from "./style-component";
import InputAction from "../../input-action/input-action";
import TextNoteWithProcess from "../../text-node-with-process/text-node-with-process";
import ModalWrapper from "../../modal-wrapper/modal-wrapper";
import HelpTooptipsGroup from "../tooltips/help-tooltips-group";

const ModalValidateUsername: React.FC<MakePostModalsProps> = ({
  open = false,
  process,
  loading,
  setOpen,
  value,
  setValue,
  handleSubmitUsername,
  socialMediaName,
  error = ''
}) => {
  const handleClose = useCallback(() => {
    if (!loading) {
      setOpen(false);
    }
  }, [setOpen, loading]);

  const validateSocialMediaUrl = (val: string) => {
    if (!val.startsWith('http')) return false;

    const urlPatterns: { [key: string]: string[] } = {
      'Facebook': ['facebook.com', 'fb.com'],
      'X': ['x.com', 'twitter.com'],
      'Twitter': ['twitter.com', 'x.com'],
      'Instagram': ['instagram.com'],
      'TikTok': ['tiktok.com'],
    };

    try {
      const urlObj = new URL(val);
      const hostname = urlObj.hostname.replace('www.', '');
      const isValid = urlPatterns[socialMediaName]?.some(domain => hostname.includes(domain)) ?? true;
      return !isValid && `La URL debe ser de ${socialMediaName}`;
    } catch {
      return "URL no valida";
    }
  };

  const validateSocialMediaUrlSecure = (val: string) => {
    if (val.startsWith('http:')) {
      return "La URL debe comenzar con https://";
    }
    if (val.startsWith('https://')) {
      if (!val.startsWith('https://')) {
        return "La URL debe empezar con https://";
      }

      const countHttps = val.split("https://").length - 1;
      const countDomain = val.split(socialMediaName.toLowerCase()).length - 1;
      if (countHttps > 1 || countDomain > 1) {
        return `La URL no debe contener múltiples https:// o múltiples dominios ${socialMediaName}`;
      }

      if (!val.toUpperCase().includes(socialMediaName.toUpperCase())) {
        return `La URL debe ser de ${socialMediaName}`;
      }
    }
    return false;
  };


  const customValidations = [
    validateSocialMediaUrlSecure,
    validateSocialMediaUrl,
  ];

  return (
    <ModalWrapper
      open={open}
      title={
        <TitleStyled>Ingresa  tu <span className="brandColor3">usuario de {socialMediaName}</span> o <span className="brandColor3">el enlace de tu publicación</span> para validar tu participación</TitleStyled>
      }
      handleClose={handleClose}
    >
      <InputAction
        name="username"
        placeholder={`ej. username o https://${socialMediaName.toLowerCase()}.com/username`}
        textButton="Buscar"
        value={value}
        setValue={setValue}
        onExecute={handleSubmitUsername}
        loading={loading}
        validations={customValidations}
      />
      <HelpTooptipsGroup />
      <TextNoteWithProcess process={process} loading={loading} customError={error} />
    </ModalWrapper>
  )
}

export default ModalValidateUsername;